import { Component, OnInit } from '@angular/core';
import { Customer } from '../customer.model';
import { OptionService } from '../option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.css']
})
export class SendSMSComponent implements OnInit {

  customers: Customer[] = [];
  userLoginId!: string;
  body!: string;
  selectAll: boolean = false;
  sendToOthers: boolean = false;
  othersMobileNo: string = "";
  form!: FormGroup;
  spinnerOverlay = false;
  selectedCustomers: string[] = [];
  _selectedCustomers: string[] = [];
  lstMobileNo: string[] = [];
  ballance: string = "";


  constructor(private optionService: OptionService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private localStorage: LocalStorageService) {
  }

  ngOnInit(): void {
    this.getCustomers();
    //this.getBallance();
  }

  getCustomers() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.optionService.getAllCustomers(this.userLoginId).subscribe(data => {

      for (let i = 0; i < data.length; i++) {
        let customer = {} as Customer;
        customer.id = data[i]['id'];
        customer.fullName = data[i]['fullName'];
        customer.userName = data[i]['userName'];
        customer.email = data[i]['email'];
        customer.balance = data[i]['balance'];
        customer.dept = data[i]['dept'];
        customer.approved = data[i]['approved'];
        customer.userCategoryId = data[i]['userCategoryId'];
        customer.newBallance = data[i]['newBallance'];
        customer.fcmRegToken = data[i]['fcmRegToken'];
        this.customers.push(customer);
      }

    }, error => {
      console.log(error);
    })
  }

  fillDataPost(): any {
    this.lstMobileNo = [];
    if (this.sendToOthers) {
      if (this.othersMobileNo.includes(',')) {
        var x = this.othersMobileNo.split(',');
        for (let i = 0; i < x.length; i++) {
          this.lstMobileNo.push(x[i]);
        }
      }
      else {
        this.lstMobileNo.push(this.othersMobileNo);
      }

    }
    if (this.selectAll) {
      this.lstMobileNo = this.customers.map(({ userName }) => userName);
    }
    else {
      if (this.selectedCustomers.length > 0) {
        for (let i = 0; i < this.selectedCustomers.length; i++) {
          var mobileNo = this.customers.find(x => x.id == this.selectedCustomers[i])?.userName;
          this.lstMobileNo.push(mobileNo!);
        }
      }
    }

    var obj = {
      message: this.body,
      lstmobilesNo: this.lstMobileNo
    }

    return obj;

  }

  sendSMS() {

    this.spinnerOverlay = true;
    var obj = this.fillDataPost();
    console.log(obj);
    // this.optionService.sendBulkSMS(obj).subscribe(data => {

    //   this.openSnackBar(this.translateService.instant("sendSuccessfully"), 'snackBarSuccess');
    //   this.body = "";
    //   this.selectedCustomers = [];
    //   this.spinnerOverlay = false;
    //   this.getBallance();

    // },
    //   error => {
    //     console.log(error)
    //     if (error.error.message != undefined) {
    //       this.openSnackBar(error.error.message, 'snackBarError');
    //     }
    //     else {
    //       this.openSnackBar("Internal server error", 'snackBarError');
    //     }
    //     this.spinnerOverlay = false;
    //   });

  }


  submit() {
    this.sendSMS();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  onChangeSendToOther() {
    this.selectAll = false;
    this.selectedCustomers = [];
  }

  onChangeSelectAll() {
    this.sendToOthers = false;
    this.othersMobileNo = "";
  }

  // getBallance() {
  //   this.optionService.getSMSBallance().subscribe(data => {
  //     this.ballance = data["message"];
  //   },
  //     error => {
  //       console.log(error);
  //     })
  // }
}
